import React from "react";

import { UncontrolledDropdown } from "../Dropdown/Dropdown";
import { DropdownItem } from "../DropdownItem/DropdownItem";
import { DropdownToggle } from "../DropdownToggle/DropdownToggle";
import { DropdownMenu } from "../DropdownMenu/DropdownMenu";
import { NavItem } from "../NavItem/NavItem";

import { Item } from "./VSETHNavbar";
import {
  ReactRouterDropDownLink,
  ReactRouterNavBarLink,
} from "./reactRouterHelper";
import { LinkConstructor } from "../../types";

interface Props {
  item: Item;
  NavLink: LinkConstructor;
}
export const ItemComponent: React.FC<Props> = ({
  item: { childItems, icon: Icon, title, disabled, linkProps, active, href },
  NavLink,
}) => {
  if (childItems) {
    return (
      <UncontrolledDropdown nav inNavbar>
        <DropdownToggle nav caret>
          {Icon && <Icon size="1em" />}
          {title}
        </DropdownToggle>
        <DropdownMenu right>
          {childItems.map((child, i) =>
            child.linkProps ? (
              <NavLink
                key={i}
                component={ReactRouterDropDownLink}
                {...child.linkProps}
                disabled={child.disabled}
              >
                {child.title}
              </NavLink>
            ) : (
              <DropdownItem
                key={i}
                active={child.active}
                disabled={child.disabled}
                onClick={child.onClick}
                href={child.href}
              >
                {child.title}
              </DropdownItem>
            )
          )}
        </DropdownMenu>
      </UncontrolledDropdown>
    );
  } else {
    return linkProps ? (
      <NavLink
        component={ReactRouterNavBarLink}
        {...linkProps}
        disabled={disabled}
        exact
      >
        {Icon && <Icon />}
        {title}
      </NavLink>
    ) : (
      <NavItem active={active}>
        <NavLink href={href} disabled={disabled}>
          {Icon && <Icon />}
          {title}
        </NavLink>
      </NavItem>
    );
  }
};
